
import React from 'react';
import { FileText, Download } from 'lucide-react';

interface ExcelDownloadCardProps {
  onDownload: () => void;
}

const ExcelDownloadCard: React.FC<ExcelDownloadCardProps> = ({ onDownload }) => {
  return (
    <div className="bg-white p-6 md:p-8 rounded-lg shadow-md border border-gray-200 mb-6">
      <div className="flex items-center gap-3 mb-4">
        <FileText className="text-brand-red" size={24} />
        <h3 className="font-semibold text-xl">Ontvang uw resultaten</h3>
      </div>
      <p className="text-gray-600 mb-6">
        Ontvang uw resultaten voor nog meer details en aanpasbare berekeningen.
      </p>
      <button 
        onClick={onDownload}
        className="btn-outline w-full flex items-center justify-center gap-2"
      >
        <Download size={18} />
        Ontvang uw resultaten
      </button>
    </div>
  );
};

export default ExcelDownloadCard;
